import { useQueryClient } from '@tanstack/react-query'

import { PendingChanges, PendingChangesResponse } from 'api/types/pendingChangesApiTypes'
import { useOrgQueryKey } from 'hooks/utils/useOrgQueryKey'

import { QueryKey } from '../queryKeys'

/**
 * Hook that provides a function to optimistically update pending changes flags.
 * Use this in mutation onSuccess handlers to immediately show the pending changes
 * status in the Data Status button without waiting for a refetch.
 */
export const useOptimisticPendingChanges = () => {
  const queryClient = useQueryClient()
  const pendingChangesQueryKey = useOrgQueryKey(QueryKey.PendingChanges)

  const setPendingChangeFlag = (flag: keyof PendingChanges) => {
    queryClient.setQueryData<PendingChangesResponse>(pendingChangesQueryKey, (oldData) => {
      if (!oldData) {
        return oldData
      }
      return {
        ...oldData,
        pending_changes: {
          ...oldData.pending_changes,
          [flag]: new Date().toISOString(),
        },
      }
    })
  }

  return { setPendingChangeFlag }
}
